import { createSlice } from '@reduxjs/toolkit';
import { verifyOtp } from '../LoginThunk/VerifyOtpThunk';

const initialState = {
  accessToken: null,
  refreshToken: null,
  userId: null,
  userDetails: null,
  isOtpVerified: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserData: (state, action) => {
      console.log("Setting user data in slice:", action.payload);
      const { accessToken, refreshToken, userId, userDetails, loggedInUserID } = action.payload;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.userId = loggedInUserID || userId;
      state.userDetails = userDetails;
      state.isOtpVerified = true;
    },
    clearUserData: () => initialState,
    updateUserDetails: (state, action) => {
      if (!action.payload) return;
      state.userDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyOtp.fulfilled, (state, action) => {
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.isOtpVerified = false;
        state.userDetails = null;
      });
  },
});

export const { setUserData, clearUserData, updateUserDetails } = userSlice.actions;
export default userSlice.reducer;
